export enum EmailNotificationTypeEnum {
  AUTO_CANCEL = 'AUTO_CANCEL',
  HELIOS_IMPORT = 'HELIOS_IMPORT',
  CONTRACT_REGISTER = 'CONTRACT_REGISTER',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_RETURN = 'DOCUMENT_RETURN',
}
